import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { GreenplumTableDataset } from 'app/model/dataset/greenplum.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.greenplum.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(GreenplumTableDataset) }
})
export class GreenplumCopySource extends TabularCopySource {
}
